import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/chigua";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
            : "bg-transparent"
        }`}
      >
        <nav className="chigua-container mx-auto flex h-16 md:h-[72px] items-center justify-between" aria-label="主导航">
          {/* Logo */}
          <a href="#top" className="flex items-center gap-2 shrink-0">
            <span
              className="grid h-9 w-9 md:h-10 md:w-10 place-items-center rounded-2xl bg-primary-500 text-background-50"
              aria-hidden="true"
            >
              <i className="ri-fire-fill text-lg md:text-xl"></i>
            </span>
            <span className="leading-none">
              <span className="font-display block text-lg md:text-xl text-primary-600">吃瓜中心</span>
              <span className="mt-1 hidden text-[10px] tracking-[0.2em] text-foreground-500 sm:block">
                MELON HUB · 情报站
              </span>
            </span>
          </a>

          {/* Desktop links */}
          <div className="hidden items-center gap-1 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 md:gap-3">
            <a
              href="#feed"
              className="grid h-9 w-9 place-items-center rounded-full text-foreground-600 transition-colors hover:bg-background-200 hover:text-primary-600"
              aria-label="搜索热点"
              title="搜索热点"
            >
              <i className="ri-search-line text-lg"></i>
            </a>
            <a
              href="#about"
              className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              <i className="ri-hotspot-fill"></i> 我要爆料
            </a>
            <button
              type="button"
              className="grid h-9 w-9 place-items-center rounded-full text-foreground-700 hover:bg-background-200 lg:hidden"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-4-line"} text-xl`}></i>
            </button>
          </div>
        </nav>
      </header>

      {/* Mobile menu */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-opacity duration-300 ${
          open ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <div className="absolute inset-0 bg-foreground-950/30 backdrop-blur-sm" onClick={() => setOpen(false)}></div>
        <div className="absolute left-0 top-16 h-[calc(100vh-4rem)] w-[78%] max-w-xs rounded-r-2xl bg-background-50 p-6 shadow-xl">
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400">情报导航</p>
          <div className="mt-4 flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-xl px-4 py-3 text-[15px] font-medium text-foreground-800 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {l.label}
                <i className="ri-arrow-right-s-line text-foreground-300"></i>
              </a>
            ))}
          </div>
          <a
            href="#about"
            onClick={() => setOpen(false)}
            className="mt-6 flex items-center justify-center gap-2 rounded-full bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
          >
            <i className="ri-hotspot-fill"></i> 我要爆料
          </a>
          <div className="mt-8 rounded-2xl bg-background-100 p-4">
            <p className="text-sm font-semibold text-foreground-800">今日榜单已更新</p>
            <p className="mt-1 text-xs text-foreground-500">10 条热榜 · 8 篇速递 · 1 篇深度</p>
          </div>
        </div>
      </div>
    </>
  );
}